import { EnquiryStatus } from "../../../../types/enquiries";

export const STATUS_CONFIG: Record<
  EnquiryStatus,
  { label: string; initial: string; bgClass: string; textClass: string }
> = {
  new: {
    label: "New",
    initial: "N",
    bgClass: "bg-blue-500",
    textClass: "text-white"
  },
  in_progress: {
    label: "In Progress",
    initial: "I",
    bgClass: "bg-amber-500",
    textClass: "text-white"
  },
  complete: {
    label: "Complete",
    initial: "C",
    bgClass: "bg-green-500",
    textClass: "text-white"
  },
  cancelled: {
    label: "Cancelled",
    initial: "X",
    bgClass: "bg-gray-500",
    textClass: "text-white"
  },
  lost: {
    label: "Lost",
    initial: "L",
    bgClass: "bg-red-500",
    textClass: "text-white"
  },
  deleted: {
    label: "Deleted",
    initial: "D",
    bgClass: "bg-red-700",
    textClass: "text-white"
  }
};

export const STATUS_ACTIONS: { value: EnquiryStatus; label: string }[] = [
  { value: "in_progress", label: "Mark in progress" },
  { value: "complete", label: "Mark complete" },
  { value: "cancelled", label: "Cancel enquiry" },
  { value: "lost", label: "Mark as lost" },
  { value: "deleted", label: "Delete enquiry" }
];
